export default "__VITE_ASSET__1247460b__"